module.exports = __webpack_public_path__ + "static/media/Stella Zhou.d48f40ee.png";